import apiClient from './apiClient';
import type { 
  PlayerSearchRequest, 
  PlayerSearchResponse 
} from '../types/player';

class PlayerSearchService {
  private baseUrl = '/sporting';

  async searchPlayersAI(request: PlayerSearchRequest): Promise<PlayerSearchResponse> {
    // Use the correct /query endpoint from backend
    const response = await apiClient.post('/query', {
      texto: request.query,
      limit: request.limit || 50,
      offset: request.offset || 0
    });
    
    // Handle both new standardized format and legacy format
    if (response.data.success && response.data.data) {
      // New format: {success: true, message: "...", data: {jugadores, total, filtros_aplicados}}
      return {
        jugadores: response.data.data.jugadores || [],
        total: response.data.data.total || 0,
        filtros_aplicados: response.data.data.filtros_aplicados || {},
        consulta_original: response.data.message || 'Búsqueda completada',
        resultados_mostrados: response.data.data.jugadores?.length || 0
      };
    } else {
      // Legacy format: {jugadores, total, filtros_aplicados}
      return {
        jugadores: response.data.jugadores || [],
        total: response.data.total || 0,
        filtros_aplicados: response.data.filtros_aplicados || {},
        consulta_original: 'Búsqueda completada',
        resultados_mostrados: response.data.jugadores?.length || 0
      };
    }
  }

  async searchSimilarPlayers(query: string) {
    const response = await apiClient.get(`${this.baseUrl}/players/search-similar?query=${encodeURIComponent(query)}`);
    return response.data;
  }
}

export const playerSearchService = new PlayerSearchService();
